import "./ShimmerLoading.css";

const ShimmerLoadingThree = () => {
  return (
    <div className="shimmer-container">
      {/* Avatar */}
      <div className="shimmer-avatar"></div>

      {/* Title + subtitle */}
      <div className="shimmer-title"></div>

      <div className="shimmer-card-1"></div>
      <div className="shimmer-card-1"></div>
    </div>
  );
};

export default ShimmerLoadingThree;
